export const appsUserAgent = 'RenaultBankApp';
export const isRenaultApp = () => navigator.userAgent.startsWith('RenaultBankApp');
